module.exports = __webpack_public_path__ + "static/media/0202dco-whiteboarding.9095b516.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/0202dco-whiteboarding.jpg
// module id = 391
// module chunks = 0